import axios, { AxiosResponse } from 'axios';
import { con } from '../../../application/entity/Rutas';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

export class SVCMatricula {
    public static async GenerarMatricula(idProceso: number, codNegocio: number, idPeriodo: number, idPersona: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'GeneraMatricula/saveGeneraMatricula';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .post(
                url,
                {
                    idProceso: idProceso,
                    codigoNegocio: codNegocio,
                    idPeriodo,
                    idPersona
                },
                {
                    params: {
                        idProceso: idProceso,
                        codigoNegocio: codNegocio,
                        idPeriodo,
                        idPersona
                    },
                },
            )
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
           .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtenerMatricula(
        rut: number,
        codPrograma: string,
        codigoNegocio: number,
        codigoPlanificacion: number,
        idPeriodo: number,
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'GeneraMatricula/getTieneMatricula';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .get(url, {
                params: {
                    rut: rut,
                    codigPrograma: codPrograma,
                    codigoNegocio: codigoNegocio,
                    codigoPlanificacion: codigoNegocio === 1 ? 0 : codigoPlanificacion,
                    idPeriodo: idPeriodo
                },
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
           .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async GenerarComprobanteMatricula(
        rut: number,
        codigoPrograma: string,
        anio: number,
        periodo: number,
        folio: number,
        codNegocio: number,
        codigoPlanificacion: number,
        idPeriodo: number,
        idPersona: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'ComprobanteMatricula/getPDFComprobanteMatricula';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .post(url, {
                rut: rut,
                codigoPrograma: codigoPrograma,
                anio: anio,
                periodo: periodo,
                folio: folio,
                codigoNegocio: codNegocio,
                codigoPlanificacion: codNegocio === 1 ? 0 : codigoPlanificacion,
                idPeriodo: idPeriodo,
                idPersona: idPersona
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
           .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async EnvioCorreo(
        rut: number,
        base64: string,
        codNegocio: number,
        declaracion: string,
        idPeriodo: number, 
        idPersona: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'Email/sendEmail';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .post(url, {
                rut: rut,
                base64: base64,
                codigoNegocio: codNegocio,
                declaracion: declaracion,
                idPeriodo: idPeriodo,
                idPersona: idPersona
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
           .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async EnvioCorreoDeclaracion(
        rut: number,
        base64: string,
        nombre: string,
        carrera: string,
        codPrograma: string,  
        planificacionAcademica: number,
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'Email/sendEmailDeclaracion';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .post(url, {
                rut: rut,
                base64: base64,
                nombre: nombre,
                carrera: carrera,
                codigoprograma: codPrograma,
                planificacionAcademica: planificacionAcademica,
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
           .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
}
